import Vue from "vue";

export default class AlertService {
  private group: string = "WtcApp";

  constructor() {}

  public success(title: string, message: string) {
    Vue.notify({
      group: this.group,
      title: title,
      text: message,
      type: "success"
    });
  }

  public warn(title: string, message: string) {
    Vue.notify({
      group: this.group,
      title: title,
      text: message,
      type: "warn"
    });
  }

  public error(title: string, message: string) {
    Vue.notify({
      group: this.group,
      title: title,
      text: message,
      type: "error"
    });
  }
}
